import React, { useEffect, useState } from 'react';
// import styles from './RepoweringRCRAFilter.module.scss';
import styles from '../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

let checkAll = false;

const RepoweringRCRAFilter = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  const [checkAllCheckbox, setCheckAllCheckbox] = useState<Array<any>>([]);
  const options = {
    "Solar Renewable Energy": {
      param: "MAP_SYMBOL_CODE LIKE '%R%' AND REPOW_RCRA LIKE '%S%'",
      isIncluded: false,
      objectIds: null
    },
    "Wind Renewable Energy": {
      param:  "MAP_SYMBOL_CODE LIKE '%R%' AND REPOW_RCRA LIKE '%W%'",
      isIncluded: false,
      objectIds: null
    },
    "Biomass Renewable Energy": {
      param:  "MAP_SYMBOL_CODE LIKE '%R%' AND REPOW_RCRA LIKE '%B%'",
      isIncluded: false,
      objectIds: null
    },
    "Geothermal Renewable Energy": {
      param: "MAP_SYMBOL_CODE LIKE '%R%' AND REPOW_RCRA LIKE '%G%'",
      isIncluded: false,
      objectIds: null
    }
  };

  const toggleAll = () => {
    // switch checkAll
    checkAll = !checkAll;
    for (let option in options) {
        
        if (checkAll) {
            // set all isIncludeds to false so they can be set to true from buildCheckBoxDivs()
            options[option]["isIncluded"] = false;
        } else if (!checkAll) {
            // switch all isIncludeds to true so they can be switched back to false by toggleParam()
            options[option]["isIncluded"] = true; 
            toggleParam(option);
        }
    }
    buildCheckboxDivs();
}

  
  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  const passUpdatedParams = () => {
    let paramArray: Array<any> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    props.updateRCRAParams(paramArray);
  }

  const buildCheckAllCheckboxDiv = () => {
    let checkAllDiv;
    if (!checkAll) {
      checkAllDiv =
        <div className={styles.SectionTitleDivs}>
          <CalciteCheckbox name={"toggleAllRCRA"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
          <label className={styles.FilterSectionLabels}>RCRA Hazardous Waste - Corrective Actions</label>
        </div>;
    } else if (checkAll) {
      checkAllDiv =
        <div className={styles.SectionTitleDivs}>
          <CalciteCheckbox checked name={"toggleAllRCRA"} onCalciteCheckboxChange={() => { toggleAll() }} key={Math.random()} />
          <label className={styles.FilterSectionLabels}>RCRA Hazardous Waste - Corrective Actions</label>
        </div>;
      // toggleAll();
    }
    setCheckAllCheckbox(checkAllDiv);
  }

  const buildCheckboxDivs = () => {
    let tempArr: Array<any> = [];
    if (!checkAll) {
      for (let key in options) {
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else if (checkAll) {
      for (let key in options) {
        toggleParam(key);
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    }
    setCheckboxDivArray(tempArr);
  }

  useEffect(() => { }, [checkboxDivArray, checkAllCheckbox]);

  useEffect(() => {
    if (props.checkAllBoxes === true) {
      checkAll = true;
    } else if (props.checkAllBoxes === false || props.checkAllBoxes === undefined) {
      checkAll = false;
    }
    buildCheckAllCheckboxDiv();
    buildCheckboxDivs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signalAChange]);

  return (
    <div className={styles.Sections}>
      {checkAllCheckbox}
      <div className={styles.CheckboxSectionDivs}>
        {checkboxDivArray}
      </div>
    </div>
  );

}


export default RepoweringRCRAFilter;
